<template lang="pug">
  div
    lessonHeader
    stepTitle
    approach
    indication
    question(@answered="receiveAnswered")
    feedbackModal(:answers="answers")
    lessonFooter
</template>

<script>
import stepTitle from '@/components/step-title/step-title'
import approach from '@/components/approach/approach'
import indication from '@/components/indication/indication'
import lessonFooter from "@/components/lesson-footer/lesson-footer";
import lessonHeader from "@/components/lesson-header/lesson-header";
import buttonNext from "@/components/button-next/button-next";
import feedbackModal from "@/components/feedback-modal/feedback-modal";
import question from '@/components/question/question'
import buttonSend from "@/components/button-send/button-send";
import { mapGetters } from 'vuex';

export default {
  name: 'Step7',
  components: {
    stepTitle,    
    lessonFooter,
    lessonHeader,
    question,
    buttonNext,
    approach,
    indication,
    feedbackModal,
    buttonSend
  },
  watch: {
    currentStep: {
      handler(val) {        
        this.show = val.check || false;        
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(['currentStep'])

  },
  data(){
    return{
        answers: [],
        showFeedback: false,
        show: false
    }
  },
  mounted:function(){
    this.show = false;
    this.showFeedback = false;
    console.log('SHOW S7: %o', this.show);
  },
  methods:{
    receiveAnswered(event){
        this.answers = event;
        this.show = true;
        this.showFeedback = false;
    }
  }
}
</script>